// LastInReport.tsx
import React, { useMemo, useState } from 'react';
import { Box, Button, Paper, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { DataGrid, GridColDef, type GridRenderCellParams, type GridRowIdGetter } from '@mui/x-data-grid';
import dayjs, { Dayjs } from "dayjs";
import { useFetch } from '../../../hooks/useFetch2.ts';
import { Event, reportApi } from './api/api.ts';
import { LocalizedDatePicker } from '../../localizedDatePicker/LocalizedDatePicker.tsx';

// debug
const columns: GridColDef<Event>[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'ts_start', headerName: 'Момент', width: 100, },
//   { field: 'lpr_subtenant_name', headerName: 'Субарендатор', width: 180, valueFormatter: (value) => value ?? '—' },
//   { field: 'lpr_group_name', headerName: 'Группа', width: 180, valueFormatter: (value) => value ?? '—' },
//   { field: 'lpr_entity_name', headerName: 'Объект', width: 180, valueFormatter: (value) => value ?? '—' },
  { field: 'matched_number', headerName: 'matched_number', width: 180, },
  { field: 'registration_number', headerName: 'registration_number', width: 180, },
  { field: 'car_brand', headerName: 'car_brand', width: 180, },
  { field: 'car_owner', headerName: 'car_owmer', width: 180, },
  { field: 'group_id', headerName: 'group_id', width: 180, },
  { field: 'entity_id_1', headerName: 'entity_id_1', width: 180, },
  { field: 'subtenant_id', headerName: 'subtenant_id', width: 180, },
  { field: 'customer_id', headerName: 'customer_id', width: 180, },
];

export const LastInReport: React.FC = () => {
    const [from, setFrom] = useState<Dayjs | null>(dayjs().startOf("day"));
    const [ period_days, setPeriod_days] = useState<number>(1);
    const { data, setData, error, update } = useFetch<Event[]>(reportApi.getEventLastIn, [], { moment: from?.toISOString(), period_days, });

    const handleRefresh = () => {
        setData([]);
        update({ moment: from?.toISOString(), period_days });
    };

    return (
        <Box sx={{ width: '100%', p: 2 }}>

            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
                {/* Звіт про подію останнього прибуття */}
            </Typography>

            {/* Контейнер для панели инструментов */}
            <Box 
                sx={{ 
                    display: 'flex', 
                    gap: 2,             // Отступы между элементами
                    alignItems: 'center', // Выравнивание по вертикали (чтобы все были на одной линии)
                    mb: 3,              // Отступ снизу до таблицы
                    flexWrap: 'wrap'    // На случай узких экранов
                }}
            >
                <LocalizedDatePicker
                    value={from}
                    onChange={(v) => setFrom(v)}
                    slotProps={{ textField: { size: 'small' } }} // Делаем высоту компактной
                    sx={{ width: 200 }}
                />
                
                <TextField
                    label="Період"
                    type="number"
                    size="small" // Задаем ту же высоту, что и у DatePicker
                    value={period_days}
                    onChange={(e) => {
                        const val = parseInt(e.target.value, 10);
                        setPeriod_days(isNaN(val) ? 0 : val);
                    }}
                    sx={{ width: 120 }} // Ограничиваем ширину, чтобы он не растягивался
                />

                <Button
                    variant="contained"
                    onClick={handleRefresh}
                    size="medium" // Чуть больше, чтобы идеально встать вровень с size="small" инпутов
                    sx={{ height: 40 }} // Либо явно фиксируем высоту кнопки под инпуты
                >
                    Оновити {/* или твой перевод {('refresh')} */}
                </Button>
            </Box>
            
            {/* Таблица */}
            <DataGrid
                getRowId={(row: Event) => `${row.ts_start}_${row.registration_number}` }
                rows={data || []}
                columns={columns}
                pageSizeOptions={[10, 25, 100]}
                initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                }}
                disableRowSelectionOnClick
                autoHeight // Чтобы сетка не сжималась и подстраивалась под контент
            />
        </Box>
    )
}
